import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  {
    title: {
      alignItems: "center",
      display: "inline-flex",
    },
  },
  { name: "GiftCardUpdatePageHeader" },
);

export default useStyles;
